import { render, staticRenderFns } from "./AddCustomers.vue?vue&type=template&id=220d24af"
import script from "./AddCustomers.vue?vue&type=script&lang=js"
export * from "./AddCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports